import { render, staticRenderFns } from "./TransportadorTable.vue?vue&type=template&id=2a3f7ab6"
import script from "./TransportadorTable.vue?vue&type=script&lang=js"
export * from "./TransportadorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports